import { c as _c } from "react/compiler-runtime";
const RatingNumber = (t0) => {
    const $ = _c(6);
    const { rating, className } = t0;
    const t1 = rating / 10;
    let t2;
    if ($[0] !== t1) {
        t2 = t1.toFixed(1);
        $[0] = t1;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const trueRating = t2;
    const computedClassName = `font-semibold text-gray-500 ${className}`;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <meta itemProp="worstRating" content="0"/>;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    let t4;
    if ($[3] !== computedClassName || $[4] !== trueRating) {
        t4 = <>{t3}
      <span className={computedClassName} itemProp="ratingValue">
        {trueRating}
      </span></>;
        $[3] = computedClassName;
        $[4] = trueRating;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    return t4;
};
export default RatingNumber;
